import { render, staticRenderFns } from "./EditCollection.vue?vue&type=template&id=036d9612&"
import script from "./EditCollection.vue?vue&type=script&lang=js&"
export * from "./EditCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports